import { DialogHeight } from "./dialog-height.model";
import { DialogPresentation } from "./dialog-presentation.model";

export { DialogHeight } from "./dialog-height.model";
export { DialogPresentation } from "./dialog-presentation.model";

export enum DialogSize {
	Small = "small",
	Medium = "medium",
	Large = "large",
	XLarge = "xlarge",
	Default = "default",
	MaxWidth = "max-width",
	MinWidth = "min-width",
}

export function dialogSizePanelClass(size: DialogSize, ...extras: (DialogHeight | DialogPresentation | string)[]): string[] {
	return [size, ...extras];
}
